import {Box, Skeleton, Stack} from '@mui/material';

type ContentSkeletonProps = {
    variant?: 'list' | 'details' | 'form' | 'inline';
    rows?: number;
};

/** Keeps the page structure visible while API data is being loaded. */
export const ContentSkeleton = ({variant = 'list', rows = 5}: ContentSkeletonProps) => {
    if (variant === 'inline') {
        return <Stack spacing={1} aria-busy="true"><Skeleton/><Skeleton width="72%"/><Skeleton width="45%"/></Stack>;
    }

    if (variant === 'details') {
        return (
            <Stack spacing={2} aria-busy="true">
                <Skeleton variant="rounded" height={132}/>
                <Skeleton variant="rounded" height={260}/>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Skeleton variant="rounded" width={96} height={38}/>
                    <Skeleton variant="rounded" width={96} height={38}/>
                </Stack>
            </Stack>
        );
    }

    if (variant === 'form') {
        return (
            <Stack spacing={2} aria-busy="true">
                <Skeleton variant="rounded" height={56}/>
                <Skeleton variant="rounded" height={56}/>
                <Skeleton variant="rounded" height={120}/>
                <Skeleton variant="rounded" height={44} width={150} sx={{alignSelf: 'flex-end'}}/>
            </Stack>
        );
    }

    return (
        <Box aria-busy="true">
            <Skeleton variant="rounded" height={48} sx={{mb: 2}}/>
            <Stack spacing={1}>
                {Array.from({length: rows}, (_, index) => <Skeleton key={index} variant="rounded" height={64}/>)}
            </Stack>
        </Box>
    );
};
